import conversations from './conversations';
import messages from './messages';
import general from './general';

export default {
  ...general,
  ...conversations,
  ...messages,
};
